module.exports = __webpack_public_path__ + "static/media/community-store-icon.2783aeff.svg";